import { ActivatedRoute, Route, Router, UrlTree } from '@angular/router';
import { NavigationInfo, Routing } from '@barthauer/abc/core';

export class LoginComponentInfo {
  public static readonly ROUTE_PATH: string = 'login';
  public static readonly ROUTE_MARKER_TAG: string = 'login';

  public static getLoginPageRoute(router: Router): Route {
    return Routing.findRoute(router.config, this.ROUTE_PATH, this.ROUTE_MARKER_TAG);
  }

  public static isCurrentPageLoginPage(router: Router): boolean {
    return Routing.doesCurrentPageMatchRoute(router, this.getLoginPageRoute(router));
  }

  public static createLoginPageNavigationInfo(router: Router, route: ActivatedRoute): NavigationInfo {
    const loginPageRoute: Route = Routing.findRoute(router.config, this.ROUTE_PATH, this.ROUTE_MARKER_TAG);

    if (!loginPageRoute) {
      throw new Error('Login page route not found!');
    }

    return Routing.createNavigationInfo(loginPageRoute, route);
  }

  public static navigateToLoginPage(router: Router, route: ActivatedRoute): Promise<boolean> {
    const naviInfo: NavigationInfo = this.createLoginPageNavigationInfo(router, route);

    return router.navigate(naviInfo.Commands, naviInfo.Extras);
  }

  public static createLoginPageUrlTree(router: Router, route: ActivatedRoute): UrlTree {
    const naviInfo: NavigationInfo = this.createLoginPageNavigationInfo(router, route);

    return router.createUrlTree(naviInfo.Commands, naviInfo.Extras);
  }
}
